import { render, staticRenderFns } from "./PausaPranzo.vue?vue&type=template&id=07ccf4ca&scoped=true&"
import script from "./PausaPranzo.vue?vue&type=script&lang=js&"
export * from "./PausaPranzo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ccf4ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Attivita\\SVILUPPO Laravel\\archilogy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07ccf4ca')) {
      api.createRecord('07ccf4ca', component.options)
    } else {
      api.reload('07ccf4ca', component.options)
    }
    module.hot.accept("./PausaPranzo.vue?vue&type=template&id=07ccf4ca&scoped=true&", function () {
      api.rerender('07ccf4ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/PausaPranzo.vue"
export default component.exports